import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { spacingClassNamePropType } from '../../__utils/spacingClassNamePropType';
import giveWarning from '../../__utils/warning';

const Text = ({ children, level, isTight, color, hideOverflow, className, qaId }) => {
  const textClasses = classNames({
    'uni-text': level === 'default',
    'uni-text--small': level === 'small',
    'uni-text--micro': level === 'micro',
    'uni-text--large': level === 'large',
    'uni-text--set-solid': level !== 'large' && isTight,
    'uni-text--nonessential': level === 'additional',
    [`uni-text--${color}`]: color,
    'u-text-overflow': hideOverflow,
    [className]: className,
  });

  if (level === 'additional') {
    giveWarning(
      'The additional level is deprecated and will be removed in the next major ' +
        'release of uniform-ui-components. Use color = nonessential instead'
    );
  }

  return (
    <p className={textClasses} data-qa-id={qaId}>
      {children}
    </p>
  );
};

Text.propTypes = {
  children: PropTypes.node,
  level: PropTypes.oneOf(['default', 'small', 'micro', 'large', 'additional']),
  isTight: PropTypes.bool,
  color: PropTypes.oneOf(['contrast', 'default', 'subtle', 'nonessential']),
  hideOverflow: PropTypes.bool,
  className: spacingClassNamePropType,
  qaId: PropTypes.string,
};

Text.defaultProps = {
  level: 'default',
  className: '',
};

export default Text;



// WEBPACK FOOTER //
// ./src/type/text/index.jsx